import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import devStatusConfig from '../helpers/devStatusConfig';

const DevStatusLabel = ({ status = '' }) => (
  <span className="tickets-index-page__dev-status-label">
    {devStatusConfig[status].icon}
    {I18n.t(`tickets.dev_statuses.${status}`)}
  </span>
);

DevStatusLabel.propTypes = {
  status: string,
};

export default DevStatusLabel;
